/**
 * Dynamic Currecy Tag Replacer
 */

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var user = require('user');
    var config = require('config');
    var BaseReplacerView = require('common/base.replacer.view');

    var currencyTags = config.get('dynamicCurrencyTags.tags');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        initialize: function() {
            BaseReplacerView.prototype.initialize.apply(this, arguments);
        },

        subscribe: function() {
            this.listenTo(user, 'change:currencyCode', this.render);
        },

        render: function() {
            var currency = user.get('currencyCode');

            this.$el.html(!_.isEmpty(currencyTags[this.options.name][currency])
                ? currencyTags[this.options.name][currency]
                : this.options.name
            );
            return this;
        }
    }, {
        nameOfReplacers: _.keys(currencyTags)
    });
});